import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AccordionService {
    public activeAccordion: HTMLElement | null;
    public subscribers: Array<(el: HTMLElement) => void> | null;

    constructor() {
        this.activeAccordion = null;
        this.subscribers = [];
    }

    public setActiveAccordion(el: HTMLElement): void {
        this.subscribers?.forEach(func => func(el));
    }

    public subscribeToChanges(callback: (el: HTMLElement) => void): void {
        this.subscribers?.push(callback);
    }
}
